module.exports = __webpack_public_path__ + "img/symbol_10.53926d74.png";